export default "__VITE_ASSET__Co6Dj4$O__"